'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var CopyToClipboardIcon = function CopyToClipboardIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      _ref$filled = _ref.filled,
      filled = _ref$filled === undefined ? false : _ref$filled,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['color', 'size', 'filled', 'className', 'children']);

  var classes = 'calcite-icon';
  if (className) classes += ' ' + className;

  if (size <= 16) {
    return _react2.default.createElement('svg', _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: '0 0 16 16',
      className: classes
    }), filled ? _react2.default.createElement('path', {
      d: 'M10.998 14a1 1 0 0 1-.707-.293l-2.998-3a1 1 0 0 1 0-1.414l2.998-3A1 1 0 0 1 10.998 6H12V2h-1v2H3V2H1v14h11v-2zM3 6h4v1H3zm0 3h2v1H3zm4 4H3v-1h4zm3.998-6h2l-2 2H16v2h-5.002l2 2h-2L8 10zM4 1h2V.682A.682.682 0 0 1 6.682 0h.636A.682.682 0 0 1 8 .682V1h2v2H4z'
    }) : _react2.default.createElement('path', {
      d: 'M16 10H8.767l1.558 1.558-.707.707-2.81-2.81 2.81-2.809.707.707L8.678 9H16zM7 6H3v1h4zm-2 4H3V9h2zm2 3H3v-1h4zm5-2v4H2V3h1v1h8V3h1v5h1V2h-2V1H8.723a1.984 1.984 0 0 0-3.446 0H3v1H1v14h12v-5zM4 2h2v-.318A.682.682 0 0 1 6.682 1h.636A.682.682 0 0 1 8 1.682V2h2v1H4z'
    }));
  }

  if (size <= 24) {
    return _react2.default.createElement('svg', _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: '0 0 24 24',
      className: classes
    }), filled ? _react2.default.createElement('path', {
      d: 'M16.241 12H19V4h-4v1a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4H1v19h18v-7h-2.758l1.293 1.293A1 1 0 0 1 16.828 19H14a1 1 0 0 1-.707-.293l-4-4a1 1 0 0 1 0-1.414l4-4A1 1 0 0 1 14 9h2.826a1 1 0 0 1 .707 1.707zM4 14h3v1H4zm5 5H4v-1h5zm0-8H4v-1h5zm5-1h2.827l-3 3H23.95v2H13.83l2.998 3H14l-4-4zm0-5H6V3h3V1.615A.614.614 0 0 1 9.614 1h.771a.614.614 0 0 1 .615.615V3h3z'
    }) : _react2.default.createElement('path', {
      d: 'M23 14v1H10.707l2.646 2.646-.707.707L8.793 14.5l3.854-3.854.707.707L10.707 14zm-5 2h1v7H1V4h4V3h3a2 2 0 0 1 4 0h3v1h4v9h-1V5h-3v2H5V5H2v17h16zM6 6h8V4h-3V2.615A.614.614 0 0 0 10.386 2h-.771A.614.614 0 0 0 9 2.615V4H6zm3 4H4v1h5zm-5 5h3v-1H4zm0 4h5v-1H4z'
    }));
  }

  return _react2.default.createElement('svg', _extends({}, props, {
    width: size,
    height: size,
    fill: color,
    viewBox: '0 0 32 32',
    className: classes
  }), filled ? _react2.default.createElement('path', {
    d: 'M7 3h4.05a2.5 2.5 0 0 1 4.9 0H20v4H7zm18 18v10H2V5h4v3h15V5h4v11h-4.482l2.293-2.293A1 1 0 0 0 22.104 12h-3.938a1 1 0 0 0-.707.293l-5.499 5.499a1 1 0 0 0 0 1.414l5.501 5.501a1 1 0 0 0 .707.293h3.935a1 1 0 0 0 .707-1.707L20.517 21zM6 14h6v-1H6zm0 5h3v-1H6zm6 4H6v1h6zm10.103-10h-3.937l-5.5 5.499L18.169 24h3.934l-4-4H32v-3H18.104z'
  }) : _react2.default.createElement('path', {
    d: 'M30 18v1H13.674l4.332 4.332-.707.707-5.54-5.539 5.54-5.54.707.708L13.674 18zm-6 3h1v10H2V5h5V3h4.05a2.5 2.5 0 0 1 4.9 0H20v2h5v11h-1V6h-4v2H7V6H3v24h21zM8 7h11V4h-4.092A1.483 1.483 0 0 0 15 3.5a1.5 1.5 0 0 0-3 0 1.483 1.483 0 0 0 .092.5H8zm4 6H6v1h6zM6 24h6v-1H6zm0-5h3v-1H6z'
  }));
};

exports.default = CopyToClipboardIcon;